import React from 'react'
import type { CellProps } from 'react-table'
import returnBuyerType, { BuyerTypes } from '../helpers/returnBuyerType'
import LinkCell from '../../Generics/GenericLinkCell'
import type { SearchVehicle } from '../types'

export const BuyerAgent = ({
    row: {
        original: { buyerAgentId, buyerAgentName, buyerId },
    },
    cell: { value },
}: CellProps<SearchVehicle>): React.ReactNode => {
    const buyerType = returnBuyerType({ buyerAgentId, buyerAgentName })
    const id = buyerType === BuyerTypes.Agents ? buyerAgentId : buyerId

    return id ? <LinkCell href={`/details/${buyerType}?id=${id}`}>{value}</LinkCell> : <div />
}
